import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [assinatura, setAssinatura] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('heritage_token');
    const salvo  = localStorage.getItem('heritage_usuario');
    if (token && salvo) {
      api.defaults.headers.Authorization = `Bearer ${token}`;
      setUsuario(JSON.parse(salvo));
      carregarPerfil();
    } else {
      setCarregando(false);
    }
  }, []);

  const carregarPerfil = async () => {
    try {
      const { data } = await api.get('/usuarios/perfil');
      setUsuario(data);
      setAssinatura(data.assinatura);
    } catch { logout(); }
    finally { setCarregando(false); }
  };

  const login = async (email, senha) => {
    const { data } = await api.post('/auth/login', { email, senha });
    localStorage.setItem('heritage_token', data.token);
    localStorage.setItem('heritage_usuario', JSON.stringify(data.usuario));
    api.defaults.headers.Authorization = `Bearer ${data.token}`;
    setUsuario(data.usuario);
    setAssinatura(data.usuario.assinatura);
    return data.usuario;
  };

  const logout = () => {
    localStorage.removeItem('heritage_token');
    localStorage.removeItem('heritage_usuario');
    delete api.defaults.headers.Authorization;
    setUsuario(null);
    setAssinatura(null);
  };

  // Considera ativa = 'ativa' OU 'trial' ainda válido
  const temAssinatura = () => {
    if (!assinatura) return false;
    if (assinatura.status === 'ativa') return true;
    if (assinatura.status === 'trial') {
      return assinatura.trial_fim ? new Date(assinatura.trial_fim) > new Date() : false;
    }
    return false;
  };

  const ehPremium = () => temAssinatura() && assinatura?.plano_slug === 'premium';
  const ehAdmin   = () => usuario?.tipo === 'admin';
  const emTrial   = () => assinatura?.status === 'trial' && temAssinatura();
  const diasTrial = () => {
    if (!assinatura?.trial_fim) return 0;
    return Math.max(0, Math.ceil((new Date(assinatura.trial_fim) - new Date()) / 86400000));
  };

  return (
    <AuthContext.Provider value={{
      usuario, assinatura, carregando,
      login, logout, carregarPerfil,
      temAssinatura, ehPremium, ehAdmin, emTrial, diasTrial,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
